module.exports = __webpack_public_path__ + "img/food1.fa5b98c3.png";